import * as React from 'react';
import AlertOutlined from './alert-outlined';
import AlertFilled from './alert-filled';
import type { IconCombinedProps } from './types';
const AlertCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <AlertFilled ref={ref} {...rest} />;
  }
  return <AlertOutlined ref={ref} {...rest} />;
});
export default AlertCombined;